import { AuthGuard } from './shared/guards/authGuard/auth.guard';
import { UrlService } from './shared/services/url.service';
import { MainFrameModule } from './components/mainframe/mainframe.module';
import { GlobalService } from './shared/global.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng5SliderModule } from 'ng5-slider';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Libreria Transalate
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// Components
import { AppComponent } from './app.component';
import { WindowRef } from './services/windowService/WindowRef';
import { SharedModule } from './shared/shared.module';
import { SeguridadModule } from './components/seguridad/seguridad.module';
import { ConfirmationModalTokenComponent } from './components/seguridad/modal-confirmacion-token.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RegistroActivosFijosModule } from './components/funcionario/mostrar-info-activo-fijo-modal/mostrar-info-activo-fijo-modal.module';
import { CancelarVisitaMasivaModule } from './components/cancelar-agenda-masiva/cancelar-visita-masiva.module';
import { UtilService } from './shared/services/util.service';
import { CancelarAgendaVirtualComponent } from './components/UAC/agenda-virtual/cancelar-agenda-virtual/cancelar-agenda-virtual.component';
import { ReprogramarTurnoComponent } from './components/UAC/agenda-virtual/reprogramar-turno/reprogramar-turno.component';
import { HttpErrorInterceptor } from './shared/services/interceptor';
//import { ReporteMedevacComponent } from './componentes/generar-reporte/reporte-medevac/reporte-medevac.component';

// requerido para AOT
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/app/', '.json');
}
@NgModule({
  declarations: [
    AppComponent
  ],

  imports: [
    NgxSpinnerModule,
    SeguridadModule,
    MainFrameModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    RegistroActivosFijosModule,
    ReactiveFormsModule,
    FormsModule,
    NoopAnimationsModule,
    Ng5SliderModule,
    CancelarVisitaMasivaModule,
    MDBBootstrapModule.forRoot(),
    NgbModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory, // necesario para minificaciónd de aplicación en prod AOT
        deps: [HttpClient]
      },
      isolate: true
    }),
    AppRoutingModule
  ],

  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  providers: [WindowRef, GlobalService, UrlService, AuthGuard, UtilService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    }],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationModalTokenComponent]
})
export class AppModule {

}
